// extracted by mini-css-extract-plugin
export default {"separator":"BreadcrumbSeparator_separator__mpnu6","chevron":"BreadcrumbSeparator_chevron__lMkbl"};